import PromotionIcon from "assets/menu-icons/PromotionIcon";

const stocks = {
  id: 'promotions',
  type: 'group',
  children: [{
    id: 'promotions',
    title: 'Акции', 
    type: 'item',
    url: '/promotions',
    icon: PromotionIcon,
    breadcrumbs: false
  }]
}

export default stocks;